export const COLUMN_DATA = {
  Id: { name: 'Código', widthCol: '20%' },
  Percentage: { name: 'Porcentaje de ajuste', widthCol: '40%' },
  Date: { name: 'Fecha de inicio', widthCol: '40%' }
}
